import React, { useEffect, useState } from "react";
import Delete from "../../confirmation_Screen/Delete";
import "./draftQLists.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../../../../axios";
import DefaultQuestion from "../../../Create_Assessment/Create_Question/DefaultQuestion";
import QuestionListAssessment from "../../../Create_Assessment/Preview_Question_List/QuestionListAssessment";
import moment from "moment";
import UpdateQuestions from "../../../../../Components/QuestionEditCreate/UpdateQustion";
import OperationType from "../../../../../Enum/OperationTypeEnum";
import ComponentType from "../../../../../Enum/ComponentTypeEnum";
import { useSelector } from "react-redux";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { hasDescriptiveAutoAssessment } from "../../../../../Utils/features";

const DaftQLists = ({ componentType }) => {
  const { state } = useLocation();

  const isCheckAdaptiveAdd =
    JSON.parse(localStorage.getItem("isCheckAdaptive")) || false;
  const [countSkills, setCountSkills] = useState([]);
  const [countDifficulty, setCountDifficulty] = useState([]);
  const [countQsType, setCountQsType] = useState([]);
  const [isloading, setIsLoading] = useState(false);
  const [showErrorInputField, setShowErrorInputField] = useState(false);
  const [getErrorMsg, setGetErrorMsg] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [isChecked, setIsChecked] = useState(state.isChecked);
  const [viewErrorMsg, setViewErrorMsg] = useState("");
  const [hidePopupCheck, setHidePopupCheck] = useState(false);
  const [openPopupDupli, setOpenPopupDupli] = useState(false);
  const [isopenPopupDupli, isSetOpenPopupDupli] = useState(false);
  const [questionType, setQuestionType] = useState([]);
  const school_id = JSON.parse(localStorage.getItem("schoolId"));
  const [copyPrevSettings, setCopyPrevSettings] = useState(true);
  const [showProgress, setShowProgress] = useState(false);
  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );

  // 🔹 Feature flag for Descriptive Auto Assessment
  const hasDescriptiveAutoAssessmentFlag = hasDescriptiveAutoAssessment;

  const checkQuestionTypes = async () => {
    try {
      const res = await axios.get(
        `/api/v1/questionType/get/school/${school_id}`,
      );

      console.log(res.data.data, "res");

      if (res.data.data.length > 0) setQuestionType(res.data.data);
    } catch (error) {
      console.log(error, "error while fetching quwstion type");
    }
  };

  useEffect(() => {
    checkQuestionTypes();
  }, [school_id]);

  const [dropdownList, setDropdownList] = useState({
    types: questionType,
  });

  const { types } = dropdownList;

  const [assessmentDetails, setAssessmentDetails] = useState({
    id: null,
    name: null,
    description: null,
    teacher_id: null,
    type_id: null,
    assessmentTypeId: null,
    assessmentEventId: null,
    standard_id: null,
    section_id: null,
    subject_id: null,
    tags: [],
    status: null,
    total_marks: null,
    total_questions: null,
    total_duration: null,
    schedule_date: null,
    schedule_time: null,
    add_to_live_session: null,
    questions: [],
  });

  const { standard_id, subject_id, section_id } = assessmentDetails;
  const [click, setClick] = useState(false);

  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (!questions || questions.length === 0) return;

    // check agar koi question edited hai
    const hasEdited = questions.some((q) => q.is_question_edited);

    if (!hasEdited) return; // ❌ agar edited nahi hai toh save mat kar

    setTimeout(() => {
      localStorage.setItem(
        `DraftQAssesmentLocal-${state.assessmentId}`,
        JSON.stringify(questions),
      );
    }, 500);
  }, [questions]);

  useEffect(() => {
    getAssessment();
  }, [state.assessmentId]);

  const getAssessment = async () => {
    let res = await axios.get(`/api/v1/assessment/get/${state.assessmentId}`);
    console.log(res, "response of saved assessment");
    if (res) {
      const {
        id,
        name,
        description,
        teacher_id,
        type_id,
        subject_id,
        section_id,
        standard_id,
        tags,
        total_duration,
        total_marks,
        total_questions,
        assessmentEventId,
        assessmentTypeId,
        deadline,
      } = res?.data?.data;
      console.log(res?.data?.data);
      setAssessmentDetails((prev) => ({
        ...prev,
        id,
        name,
        description,
        teacher_id: teacher_id?.id,
        type_id: type_id?.id,
        subject_id,
        section_id,
        standard_id,
        assessmentEventId,
        assessmentTypeId,
        tags,
        total_duration,
        total_marks,
        total_questions,
        deadline,
      }));

      if (state?.localData) {
        const localSaved = JSON.parse(
          localStorage.getItem(`DraftQAssesmentLocal-${state.assessmentId}`) ||
            "{}",
        );
        if (localSaved) {
          setQuestions(localSaved);
          return; // stop yahin
        }
      }
      console.log("no localDAta hai");
      console.log(res.data.data.questions, "checking set questions");
      res.data.data.questions.map((question) => {
        console.log(question, "question from draft");
        setQuestions((prev) => [
          ...prev,
          {
            id: question.id,
            standard_id: question?.standard?.id,
            subject_id: question?.subject?.id,
            section_id: question?.section?.id,
            book_id: question?.book?.id,
            chapter_id: question?.chapter?.id,
            type_id: question?.type?.id,
            question_type: String(question?.type?.is_manually_graded),
            domain_id: question?.domain?.id,
            skill_id: question?.skill?.id,
            difficulty_level: question?.difficulty_level?.id,
            title: question?.title,
            correct_score: question?.correct_score,
            is_mandatory: question?.is_mandatory,
            add_to: question?.add_to,
            add_to_mock: question?.add_to_mock,
            attachments: question?.attachments,
            options: question?.options,
            correct_answers: question?.correct_answers,
            subjective_evaluation: question?.subjective_evaluation,
          },
        ]);
      });
    }
  };

  const getBaseQuestionTemplate = () => {
    const isAdaptiveSelected =
      state?.adaptive || state?.isAdaptive || state?.autoEvaluate;

    const mcqType = types?.find((t) => t.type === "multiple choice");

    return {
      standard_id: standard_id ? standard_id.id : null,
      subject_id: subject_id ? subject_id.id : null,
      section_id: section_id ? section_id.id : null,

      book_id: null,
      chapter_id: null,
      domain_id: null,
      skill_id: null,
      difficulty_level: null,

      // 🔥 adaptive handling
      question_type: isAdaptiveSelected ? "false" : "null",
      type_id: isAdaptiveSelected && mcqType ? mcqType.id : null,

      title: null,
      correct_score: 0,
      is_question_edited: false,

      is_mandatory: false,
      add_to: null,
      add_to_mock: false,

      attachments: [],

      options: [
        { key: "A", value: null },
        { key: "B", value: null },
        { key: "C", value: null },
        { key: "D", value: null },
      ],

      correct_answers: [
        {
          option_key: null,
          value: null,
          reason_for_answer: {
            attachment: null,
            explanation: null,
          },
        },
      ],
    };
  };

  const addMoreQuestion = () => {
    setQuestions((prev) => {
      const baseQuestion = getBaseQuestionTemplate();

      if (copyPrevSettings && prev.length > 0) {
        const previous = prev[prev.length - 1];

        const isMCQ = previous.question_type === "false";
        const isDescriptive =
          previous.question_type === "true" ||
          previous.question_type === "null";

        // 🔹 Build new question
        let newQuestion = {
          ...baseQuestion,

          // 🔁 copied metadata
          book_id: previous.book_id,
          chapter_id: previous.chapter_id,
          skill_id: previous.skill_id,
          domain_id: previous.domain_id,
          difficulty_level: previous.difficulty_level,
          correct_score: previous.correct_score,

          // 🔥 IMPORTANT: sync question type properly
          type_id: previous.type_id,
          question_type: previous.question_type,

          // 🔥 THIS IS THE KEY FIX
          options: isMCQ
            ? [
                { key: "A", value: null },
                { key: "B", value: null },
                { key: "C", value: null },
                { key: "D", value: null },
              ]
            : [],

          correct_answers: isMCQ
            ? [
                {
                  option_key: null,
                  value: null,
                  reason_for_answer: {
                    attachment: null,
                    explanation: null,
                  },
                },
              ]
            : [
                {
                  reason_for_answer: {
                    explanation: null,
                    attachments: null,
                  },
                },
              ],
        };

        // 🔹 Copy subjective_evaluation ONLY when:
        //    - feature flag is ON
        //    - copied type is descriptive (not MCQ)
        //    - previous question actually had subjective_evaluation
        if (
          hasDescriptiveAutoAssessmentFlag &&
          !isMCQ &&
          previous.subjective_evaluation
        ) {
          newQuestion.subjective_evaluation = {
            enabled: previous.subjective_evaluation.enabled ?? false,
            expectedAnswer: previous.subjective_evaluation.expectedAnswer || "",
            // deep copy rubric array
            rubric: Array.isArray(previous.subjective_evaluation.rubric)
              ? previous.subjective_evaluation.rubric.map((r) => ({ ...r }))
              : [],
          };
        } else if (
          hasDescriptiveAutoAssessmentFlag &&
          !isMCQ &&
          !previous.subjective_evaluation
        ) {
          // Descriptive type but previous had no subjective_evaluation → init fresh
          newQuestion.subjective_evaluation = {
            enabled: false,
            expectedAnswer: "",
            rubric: [],
          };
        }

        return [...prev, newQuestion];
      }

      return [...prev, baseQuestion];
    });
  };

  const checkAllDataField = () => {
    let hasError = false;

    questions.forEach((question, index) => {
      if (!question.title) {
        setGetErrorMsg(`Title missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.skill_id) {
        setGetErrorMsg(`Skill missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.type_id) {
        setGetErrorMsg(`Question Type missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.chapter_id) {
        setGetErrorMsg(`Book & Chapter missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.correct_score) {
        setGetErrorMsg(`Correct Score missing in question ${index + 1}`);
        hasError = true;
      }
      if (!question.difficulty_level) {
        setGetErrorMsg(`Difficulty Level missing in question ${index + 1}`);
        hasError = true;
      }

      if (componentType === ComponentType.QUESTION_BANK) {
        if (
          !question?.add_to ||
          question.add_to === null ||
          question.add_to.trim() === ""
        ) {
          setGetErrorMsg(`Add to missing in question ${index + 1}`);
          hasError = true;
        }
      }

      // 🔹 Skip option / correct_answer validation for:
      //    - Descriptive type with AI feature ON
      const isDescriptiveWithAI =
        hasDescriptiveAutoAssessmentFlag && question.question_type === "true";

      if (!isDescriptiveWithAI) {
        if (Array.isArray(question.options) && question.options.length > 0) {
          question.options.forEach((opt, optIndex) => {
            if (!opt?.key || opt.key.trim() === "") {
              setGetErrorMsg(`Option key missing in question ${index + 1}`);
              hasError = true;
            }
            if (!opt?.value || opt.value.trim() === "") {
              setGetErrorMsg(`Option value missing in question ${index + 1}`);
              hasError = true;
            }
          });
        }
      }

      if (!isDescriptiveWithAI) {
        if (Array.isArray(question.correct_answers)) {
          question?.correct_answers.forEach((ans, ansIndex) => {
            if (question?.options?.length > 0) {
              if (question?.type === "false") {
                if (!ans?.option_key || ans.option_key.trim() === "") {
                  setGetErrorMsg(`Option key missing in question ${index + 1}`);
                  hasError = true;
                }
              }
            }
          });
        }
      }
    });
    if (hasError) {
      setShowErrorInputField(true);
      return true;
    }

    return false;
  };

  const findDuplicateQuestions = () => {
    const seen = new Set();
    const duplicates = [];

    questions.forEach((question, index) => {
      const id = question.id || question.b4sQuestion;
      if (question.is_question_edited || !id) return;

      if (seen.has(id)) {
        duplicates.push(index + 1);
      } else {
        seen.add(id);
      }
    });

    if (duplicates.length > 0) {
      setViewErrorMsg(`Duplicate question found at Q${duplicates.join(", Q")}`);
      isSetOpenPopupDupli(true);
      return true; // 🔴 duplicate found
    }

    return false; // ✅ no duplicate
  };

  const handleAdaptiveQuesType = () => {
    let nonAdaptiveQustionType = [];
    let hasNonAdaptive = false;
    questions.forEach((question, index) => {
      if (isChecked) {
        const isCheckNonMCQ = question?.options?.length === 0;
        if (isCheckNonMCQ) {
          hasNonAdaptive = true;
          nonAdaptiveQustionType.push(index + 1);
        }
      }
      setHidePopupCheck(hasNonAdaptive);
    });

    if (hasNonAdaptive) {
      setOpenPopup(true);
      setViewErrorMsg(
        `Non-MCQ questions are found in Adaptive Assessment. \nPlease check the questions Q${nonAdaptiveQustionType.join(
          ", Q",
        )}`,
      );
    } else {
      setOpenPopup(false);
    }
  };

  // 🔹 NEW: Build cleaned payload respecting hasDescriptiveAutoAssessment
  const buildCleanedQuestions = (rawQuestions) => {
    return (rawQuestions || []).map((val) => {
      const q = { ...val };

      // remove id
      if (q.is_question_edited && q.id !== undefined) {
        delete q.id;
      }

      const isManuallyGraded = q.question_type === "true";

      // Feature OFF → strip subjective_evaluation
      if (!hasDescriptiveAutoAssessmentFlag) {
        delete q.subjective_evaluation;
        return q;
      }

      // Feature ON + auto-graded (MCQ etc.) → strip
      if (!isManuallyGraded) {
        delete q.subjective_evaluation;
        return q;
      }

      // Feature ON + manually graded (descriptive) → keep / clean
      const se = q.subjective_evaluation;

      const hasData =
        se &&
        (se.enabled ||
          (se.expectedAnswer && se.expectedAnswer.trim()) ||
          (Array.isArray(se.rubric) && se.rubric.length > 0));

      if (!hasData) {
        delete q.subjective_evaluation;
        return q;
      }

      const cleanedRubric = (se.rubric || []).filter(
        (r) => (r.criterion && r.criterion.trim()) || Number(r.maxMarks) > 0,
      );

      q.subjective_evaluation = {
        enabled: se.enabled ?? false,
        expectedAnswer: se.expectedAnswer || "",
        rubric: cleanedRubric,
      };

      return q;
    });
  };

  const handleCreateAssessment = async () => {
    const cleanedQuestions = buildCleanedQuestions(questions);

    const isHeavyAssessment = cleanedQuestions.length > 20;

    if (isHeavyAssessment) {
      setShowProgress(true);
    } else {
      setIsLoading(true);
    }

    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: null,
      assessmentTypeId: assessmentDetails.assessmentTypeId,
      assessmentEventId: assessmentDetails.assessmentEventId,
      academicSessionId: academicSessionId,
      timetableSessionId: timeTableSessionId,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "draft",
      isAdaptive: state?.adaptive || state?.isAdaptive ? true : false,
      autoEvalEnabled: state?.autoEvaluate ? true : false,
      total_duration: assessmentDetails.total_duration,
      questions: cleanedQuestions, // 👈 cleaned payload
    };
    console.log(newAssessment, "newAssessment");

    try {
      let res = await axios.put(
        `/api/v1/assessment/update/${assessmentDetails?.id}`,
        newAssessment,
      );
      res && navigate("/PublishedAssessment?status=Draft");
    } catch (error) {
      console.log(error);
    } finally {
      localStorage.removeItem(`DraftQAssesmentLocal-${state.assessmentId}`);
      setShowProgress(false);
      setIsLoading(false);
    }
  };

  const findTotalMarks = () => {
    return questions.reduce((acc, curr) => acc + Number(curr.correct_score), 0);
  };

  useEffect(() => {
    const dataCounter = {
      Skills: {},
      DifficultyLevel: {},
      QuestionType: {},
    };
    questions.map((item, index) => {
      const correctScore = Number(item.correct_score);
      if (item.question_type !== null) {
        if (dataCounter["QuestionType"][item.question_type] === undefined) {
          dataCounter["QuestionType"][item.question_type] = correctScore;
        } else {
          setCountDifficulty({});
          dataCounter["QuestionType"][item.question_type] += correctScore;
        }
      }
      if (item.question_type !== null) {
        if (dataCounter["Skills"][item.skill_id] === undefined) {
          dataCounter["Skills"][item.skill_id] = correctScore;
        } else {
          dataCounter["Skills"][item.skill_id] += correctScore;
        }
      }
      if (item.question_type !== null) {
        if (
          dataCounter["DifficultyLevel"][item.difficulty_level] === undefined
        ) {
          dataCounter["DifficultyLevel"][item.difficulty_level] = correctScore;
        } else {
          dataCounter["DifficultyLevel"][item.difficulty_level] += correctScore;
        }
      }
    });

    setCountQsType(dataCounter);
    setCountSkills(dataCounter);
    setCountDifficulty(dataCounter);
  }, [questions]);

  return (
    <>
      <UpdateQuestions
        operationType={OperationType.UPDATE}
        setClickFromCreate={setClick}
        assessmentDetails={assessmentDetails}
        setAssessmentDetails={setAssessmentDetails}
        componentType={componentType}
        questions={questions}
        setQuestions={setQuestions}
        addMoreQuestion={addMoreQuestion}
        checkAllDataField={checkAllDataField}
        findTotalMarks={findTotalMarks}
        handleCreateAssessment={handleCreateAssessment}
        isloading={isloading}
        showErrorInputField={showErrorInputField}
        getErrorMsg={getErrorMsg}
        setShowErrorInputField={setShowErrorInputField}
        setIsChecked={setIsChecked}
        isChecked={isChecked}
        isCheckAdaptiveAdd={isCheckAdaptiveAdd}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        findDuplicateQuestions={findDuplicateQuestions}
        handleAdaptiveQuesType={handleAdaptiveQuesType}
        viewErrorMsg={viewErrorMsg}
        hidePopupCheck={hidePopupCheck}
        setOpenPopupDupli={setOpenPopupDupli}
        openPopupDupli={openPopupDupli}
        isSetOpenPopupDupli={isSetOpenPopupDupli}
        isopenPopupDupli={isopenPopupDupli}
        selectedBox={state}
        copyPrevSettings={copyPrevSettings}
        setCopyPrevSettings={setCopyPrevSettings}
        hasDescriptiveAutoAssessment={hasDescriptiveAutoAssessmentFlag}
      />
      {showProgress && (
        <Dialog open={true} maxWidth="xs" fullWidth>
          <DialogContent
            sx={{
              textAlign: "center",
              py: 4,
            }}
          >
            {/* Loader */}
            <Box sx={{ mb: 2 }}>
              <div className="spinner-border text-primary" />
            </Box>

            {/* Title */}
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Saving Assessment as Draft...
            </Typography>

            {/* Message */}
            <Typography variant="body2" color="text.secondary">
              Please wait ⏳
              <br />
              This may take a 1-2 minutes due to large number of questions.
            </Typography>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default DaftQLists;
